<template lang="pug">
  .operator-requests
    .admin-page__title
      h1.title Заявки
    .admin-page__filters
      .select-filter
        .form
          .form__elem
            custom-select(
            :list-data="events"
            :show-list="true"
            :read-only="false"
            :type="'event'"
            :default-value="filter.event"
            @on-change-default-value="changeSelectValue"
            )
          .form__elem
            button.button.button_paint-main(
            v-if="showExportButton"
            @click.prevent="onClickGetExcelOrders"
            :class="{'loaded-button':isPendingGetExcelOrders}"
            ) Экспортировать в Excel
    .admin-page__status-filters
      status-filter(
      :status="operatorOrdersStatusTotal"
      @change="setFilter"
      :show-rejected-status="false"
      :show-reserve-status="false"
      )
    .admin-page__actions
      table-actions(
      :count="selected.length"
      @on-button-click="onClickActionButton"
      )
    .admin-page__tables
      requests-table(
      :orders="operatorOrders"
      @change="selectItem"
      )
    .admin-page__pagination(
    v-if="paginationAmountToShow < operatorOrdersAmount"
    )
      custom-pagination(
      :elements-amount="operatorOrdersAmount"
      :amount-to-show="paginationAmountToShow"
      :current-page="paginationCurrentPage"
      @on-button-click="onPaginationButtonClick"
      )
    modal(
    v-if="showModal"
    :mode="modalMode"
    :modalData="modalData"
    @close="showModal = false"
    @changeModalMode="changeModalMode"
    )
</template>

<script>
import { mapState, mapActions } from "vuex";
import OperatorTableFilter from "./components/operator-table-filter.vue";
import Modal from "../../../../components/modal/modal.vue";
import CustomPagination from "../../../../components/pagination/pagination";
import StatusFilter from "../../../../components/status-filter/status-filter";
import TableActions from "../../../../components/table-actions/table-actions";
import RequestsTable from "../../../../components/requests-table/requests-table";
import CustomSelect from "../../../../components/custom-select/custom-select";
import { OrderStatusEnums } from "../../../../const";

export default {
  name: "operator-requests-quota",
  data() {
    return {
      showModal: false,
      modalMode: "operator-modal-info",
      modalData: {},
      orders: [],
      selected: [],
      awards: [],
      areas: [],
      events: [],
      orders_status_total: [],
      params: {
        current_status__in: null,
      },
      filter: {
        event: {
          value: null,
          text: "Мероприятия",
          paramName: "title",
        },
        area: {
          value: null,
          text: "Районы",
          paramName: "name",
        },
        award: {
          value: null,
          text: "Конкурсы",
          paramName: "title",
        },
      },
      /*для пагинации*/
      ordersAmount: null,
      paginationAmountToShow: 25,

      isPendingGetExcelOrders: false,
    };
  },
  components: {
    CustomSelect,
    RequestsTable,
    TableActions,
    StatusFilter,
    CustomPagination,
    Modal,
    OperatorTableFilter,
  },
  computed: {
    ...mapState([
      "operatorOrders",
      "operatorOrdersStatusTotal",
      "operatorOrdersAmount",
    ]),
    paginationCurrentPage() {
      return Number(this.$route.query.page) || 1;
    },
    showExportButton() {
      return this.params.current_status__in === OrderStatusEnums.APPROVED;
    },
  },
  methods: {
    ...mapActions([
      "getOrders",
      "updateOrderStatusBulk",
      "getAreas",
      "getEvents",
      "getAwardTypes",
      "getExcelOrders",
    ]),
    onGetOrders(pageNumber) {
      this.params.page_size = this.paginationAmountToShow;
      this.params.page = pageNumber;
      this.getOrders(this.params);
    },
    changeSelectValue(data, type) {
      this.filter[type] = data;
      this.params.event = this.filter.event.value;
      this.params.area__in = this.filter.area.value;
      this.params.award_type__in = this.filter.award.value;
      this.onPaginationButtonClick(1);
    },
    setFilter(status) {
      if (status) {
        this.params.current_status__in = status;
      } else {
        this.params.current_status__in = null;
      }
      this.onPaginationButtonClick(1);
    },
    onPaginationButtonClick(button) {
      if (Number(this.$route.query.page) !== button) {
        this.$router.replace({ query: { page: button } });
      }
      this.onGetOrders(button);
    },

    onClickActionButton(newStatus) {
      if (this.selected.length === 0) {
        this.showModal = true;
        this.modalMode = "notification";
        this.modalData = {
          text: "Не выбрана ни одна заявка!",
          buttonText: "Продолжить",
          alignCenter: true,
        };
        return;
      }
      let differentStatuses = this.selected.findIndex(
        (item) => item.status !== this.selected[0].status
      );
      if (differentStatuses > -1) {
        this.showModal = true;
        this.modalMode = "notification";
        this.modalData = {
          text: "Выбранные заявки должны быть в одном статусе!",
          buttonText: "Продолжить",
          alignCenter: true,
        };
        return;
      }
      if (
        newStatus === OrderStatusEnums.IN_PROGRESS &&
        this.selected[0].status !== OrderStatusEnums.NEW
      ) {
        this.showModal = true;
        this.modalMode = "notification";
        this.modalData = {
          text: "Заявки в этом статусе нельзя взять в работу!",
          buttonText: "Продолжить",
          alignCenter: true,
        };
        return;
      }
      if (
        newStatus === OrderStatusEnums.RESERVE &&
        this.selected[0].status !== OrderStatusEnums.IN_PROGRESS
      ) {
        this.showModal = true;
        this.modalMode = "notification";
        this.modalData = {
          text: "Заявки в этом статусе нельзя перевести в резерв!",
          buttonText: "Продолжить",
          alignCenter: true,
        };
        return;
      }
      if (
        newStatus === OrderStatusEnums.REJECTED &&
        this.selected[0].status !== OrderStatusEnums.IN_PROGRESS
      ) {
        this.showModal = true;
        this.modalMode = "notification";
        this.modalData = {
          text: "Заявки в этом статусе нельзя отклонить!",
          buttonText: "Продолжить",
          alignCenter: true,
        };
        return;
      }
      if (newStatus === OrderStatusEnums.REJECTED) {
        this.showModal = true;
        this.modalMode = "operator-rejection";
        this.modalData.bulkRejection = true;
        this.modalData.orders = this.selected.map((el) => el.id);
        this.modalData.paramsForGetOrders = this.params;
        return;
      }
      this.updateOrderStatusBulk({
        status: newStatus,
        ids: this.selected.map((el) => el.id),
      }).then((res) => {
        if (res.status === 200) {
          this.getOrders(this.params);
          this.showModal = true;
          this.modalMode = "notification";
          this.modalData = {
            text: "Статус заявок успешно изменен!",
            buttonText: "Продолжить",
            alignCenter: true,
          };
        } else {
          this.showModal = true;
          this.modalMode = "notification";
          this.modalData = {
            text: "Не удалось изменить статус заявок!",
            buttonText: "Продолжить",
            alignCenter: true,
          };
        }
      });
    },

    changeModalMode(mode) {
      this.modalMode = mode;
    },

    onClickGetExcelOrders() {
      this.isPendingGetExcelOrders = true;
      this.getExcelOrders().then((response) => {
        const url = response.url;
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Заявки.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.isPendingGetExcelOrders = false;
      });
    },

    onGetEvents() {
      this.getEvents().then((res) => {
        this.events.push(this.filter.event);
        let eventX = res.map((event) => ({
          text: event.title,
          value: event.id,
        }));
        this.events.push(...eventX);
      });
    },
    onGetAreas() {
      this.getAreas().then((res) => {
        this.areas.push(this.filter.area);
        let areaX = res.map((area) => ({
          text: area.name,
          value: area.id,
        }));
        this.areas.push(...areaX);
      });
    },
    onGetAward() {
      this.getAwardTypes().then((res) => {
        this.awards.push(this.filter.award);
        let awardX = res.map((award) => ({
          text: award.title,
          value: award.id,
        }));
        this.awards.push(...awardX);
      });
    },

    selectItem(selected) {
      this.selected = selected;
    },
  },
  watch: {
    operatorOrders() {
      this.selected = [];
    },
  },
  mounted() {
    this.onGetAreas();
    this.onGetEvents();
    this.onGetAward();
    this.onGetOrders(this.paginationCurrentPage);
  },
};
</script>
